export interface ClaimFile {
  dossier_id: string;
  file_id: string;
  file_name: string;
  file_type: 'DOC' | 'AUDIO';
  file_scope: string;
  contents_type: string;
  mime_type?: string;
  updated_at: string;
  total_pages: number;
  received_at: string;
  file_size?: number;
  ingest_status: string;
  ingest_error?: string;
  raw_content_path?: { s3_bucket: string; s3_key: string };
  tags: string[];
  title?: string;
  toc: { data_version: string; markdown: string };
  user_note: string;
}

export type SelfServiceClaimFile = Pick<
  ClaimFile,
  'file_name' | 'received_at' | 'file_size' | 'raw_content_path'
>;

export const TEXT_MIME_TYPES = ['text/html', 'text/rtf', 'application/rtf'];

// TODO: DocumentCitations format tbd
export interface DocumentCitations {
  [documentId: string]: string;
}

export interface GetPresignedUploadResponse {
  url: string;
  contentType: string;
  metadata: Record<string, string>;
  file: File;
}
